import { styled } from '@mui/material';

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '18.5rem',
  height: '2.5rem',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.orange.light,
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  textAlign: 'center',
  flexGrow: 1,
}));
